"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var radio_group_service_1 = require("./radio-group.service");
var RadioComponent = (function () {
    function RadioComponent(el, _service) {
        this.el = el;
        this._service = _service;
    }
    Object.defineProperty(RadioComponent.prototype, "groupName", {
        get: function () {
            return this._service.fieldName.replace('.', '_');
        },
        enumerable: true,
        configurable: true
    });
    RadioComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var ele = this.el.nativeElement.getElementsByTagName('input')[0];
        this._service.optionSelected$.subscribe(function (value) {
            ele.checked = value === _this.value;
        });
        if (this._service.defaultValue === this.value) {
            window.setTimeout(function () { _this._service.announceSelectedOption(_this.value); }, 0);
        }
    };
    RadioComponent.prototype.check = function () {
        this._updateValue();
    };
    RadioComponent.prototype._updateValue = function () {
        this._service.announceSelectedOption(this.value);
    };
    return RadioComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], RadioComponent.prototype, "fg", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RadioComponent.prototype, "field", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RadioComponent.prototype, "label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], RadioComponent.prototype, "disabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RadioComponent.prototype, "nane", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RadioComponent.prototype, "value", void 0);
RadioComponent = __decorate([
    core_1.Component({
        selector: 'radio',
        template: "\n      <div class=\"radio m-b-15\" [class.disabled]=\"disabled\"><label><input type=\"radio\" [name]=\"groupName\" [disabled]=\"disabled\" [attr.value]=\"value\" (click)=\"check()\"><i class=\"input-helper\"></i>{{label}}</label></div>\n    ",
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        radio_group_service_1.RadioGroupService])
], RadioComponent);
exports.RadioComponent = RadioComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/forms/radio/radio.component.js
// module id = 62
// module chunks = 0